<ul class="nav nav-tabs mb-3">
  <li class="nav-item">
    <button
      type="button"
      class="nav-link"
      [class.active]="activeTab === '1'"
      (click)="setActiveTab('1')"
    >
      Hospital Discharge Summary
    </button>
  </li>

  <li class="nav-item">
    <button
      type="button"
      class="nav-link"
      [class.active]="activeTab === '2'"
      (click)="setActiveTab('2')"
    >
      Diagnostic Imaging Study
    </button>
  </li>

  <li class="nav-item">
    <button
      type="button"
      class="nav-link"
      [class.active]="activeTab === '3'"
      (click)="setActiveTab('3')"
    >
      Medical Images
    </button>
  </li>

  <li class="nav-item">
    <button
      type="button"
      class="nav-link"
      [class.active]="activeTab === '4'"
      (click)="setActiveTab('4')"
    >
      Laboratory Report
    </button>
  </li>
</ul>

@if (loading) {
  <div class="d-flex flex-grow-1 flex-column my-5 align-content-center justify-content-center">
    <p-progress-spinner ariaLabel="loading" />
  </div>
} @else {
  @if (activeTab) {
    <h5 class="mb-3">
      Patient Original Clinical Documents List
    </h5>

    @if (errorMessage) {
      <div class="alert alert-danger">
        {{ errorMessage }}
      </div>
    }

    @if (list.length > 0) {
      @for (item of list; track $index) {
        <div class="p-3 mb-2 bg-light border rounded">
          <div>
            <strong>Name:</strong>
            {{ getDocumentTitle(item) }}
          </div>

          <div>
            <strong>Creation date:</strong>
            {{ getDocumentDate(item) }}
          </div>

          <div>
            <strong>Class code:</strong>
            {{ item.classCode }}
          </div>

          <button
            type="button"
            class="btn btn-primary mt-3"
            (click)="retrieveDocument(item)"
          >
            Retrieve
          </button>
        </div>
      }
    } @else if (!errorMessage) {
      <div class="alert alert-info">
        No original clinical documents found.
      </div>
    }
  }

  <div #documentViewer></div>

  @if (documentLoading) {
    <div class="d-flex flex-grow-1 flex-column my-5 align-content-center justify-content-center">
      <p-progress-spinner ariaLabel="loading" />
    </div>
  }

  @if (pdfUrl) {
    <embed
      [src]="pdfUrl"
      type="application/pdf"
      width="100%"
      height="1050px"
    />
  }

  @if (imageUrl) {
    <img
      [src]="imageUrl"
      class="img-fluid"
      alt="Medical image"
    />
  }
}
